// Suggested code may be subject to a license. Learn more: ~LicenseLog:3861137655.
// Suggested code may be subject to a license. Learn more: ~LicenseLog:4263184939.
// Suggested code may be subject to a license. Learn more: ~LicenseLog:2694410378.
// Suggested code may be subject to a license. Learn more: ~LicenseLog:3241257279.
import React, { useState } from 'react';
import axios from 'axios';

import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from '@headlessui/react';

export default function ModalContact({ open, setOpen }) {
    const [formData, setFormData] = useState({
        name: '',
        identity: '',
        message: '',
    });

    const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);
    const [isSending, setIsSending] = useState(false);
    const [isErrorModalOpen, setIsErrorModalOpen] = useState(false);

    const handleInputChange = (event) => {
        setFormData({

            ...formData,
            [event.target.name]: event.target.value,
        });
    };

    const handleSubmit = async () => {
        try {
            setIsSending(true);
            const response = await window.apiClient.post('/data/message', formData);
            // console.log('Message sent successfully:', response.data);
            setOpen(false);
            setIsSuccessModalOpen(true);
            setFormData({
                name: '',
                identity: '',
                message: '',
            });

        } catch (error) {
            console.error('Error sending message:', error);
            setIsErrorModalOpen(true);
        } finally {
            setIsSending(false);
        }
    };
    return <>

        <Dialog open={open} onClose={() => setOpen(false)} className="relative z-50">
            <DialogBackdrop
                transition
                className="fixed inset-0 bg-gray-500/75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
            />
            <div className="overflow-y-auto fixed inset-0 z-10 w-screen">
                <div className="flex justify-center items-center p-4 min-h-full text-center sm:p-0">
                    <DialogPanel
                        transition
                        className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 max-w-lg w-full data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
                    >
                        <div className="px-4 pt-5 pb-4 bg-white sm:p-6 sm:pb-4">
                            <div className="sm:flex sm:items-start">
                                <div className="mt-3 w-full text-center sm:ml-4 sm:mt-0 sm:text-left">
                                    <DialogTitle as="h3" className="text-base font-semibold text-gray-900">
                                        Leave a Message
                                    </DialogTitle>
                                    <div className="mt-1">
                                        <div className="pb-12 border-b border-gray-900/10">
                                            <p className="mt-1 text-gray-600 text-sm/6">First, let us know who you are!</p>
                                            <div className="grid grid-cols-1 gap-x-6 gap-y-8 mt-10 sm:grid-cols-6">
                                                <div className="sm:col-span-3">
                                                    <label htmlFor="name" className="block font-medium text-gray-900 text-sm/6">
                                                        Name
                                                    </label>
                                                    <div className="mt-2">
                                                        <input
                                                            id="name"
                                                            name="name"
                                                            type="text"
                                                            autoComplete="name"
                                                            value={formData.name}
                                                            onChange={handleInputChange}
                                                            placeholder='I Gede Arya Krisnanda Sutasoma'
                                                            className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                                                        />
                                                    </div>
                                                </div>

                                                <div className="sm:col-span-3">
                                                    <label htmlFor="identity" className="block font-medium text-gray-900 text-sm/6">
                                                        Identity
                                                    </label>
                                                    <div className="mt-2">
                                                        <input
                                                            id="identity"
                                                            name="identity"
                                                            type="text"
                                                            autoComplete="organization-title"
                                                            value={formData.identity}
                                                            onChange={handleInputChange}
                                                            placeholder='Nama Kelompok/Alumni/Staff'
                                                            className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                                                        />
                                                    </div>
                                                </div>

                                            </div>
                                        </div>

                                        <div className="col-span-full">
                                            <label htmlFor="message" className="block font-medium text-gray-900 text-sm/6">
                                                Message
                                            </label>
                                            <div className="mt-2">
                                                <textarea
                                                    id="message"
                                                    name="message"
                                                    rows={3}
                                                    className="block px-3 py-2 w-full text-gray-900 bg-white rounded-md ring-1 ring-inset ring-gray-300 shadow-sm placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                                    value={formData.message}
                                                    onChange={handleInputChange}

                                                />
                                            </div>
                                            <p className="mt-3 text-gray-600 text-sm/6">Write your message here. We'll read it carefully.</p>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="px-4 py-3 bg-gray-50 sm:flex sm:flex-row-reverse sm:px-6">
                            <button
                                type="button"
                                onClick={handleSubmit} disabled={isSending}
                                className="inline-flex justify-center px-3 py-2 w-full text-sm font-semibold text-white bg-green-600 rounded-md shadow-sm hover:bg-green-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-green-600 sm:ml-3 sm:w-auto"
                            >
                                {isSending ? 'Sending Message...' : 'Send'}
                            </button>

                            <button
                                type="button"
                                disabled={isSending}
                                data-autofocus
                                onClick={() => setOpen(false)}
                                className="inline-flex justify-center px-3 py-2 mt-3 w-full text-sm font-semibold text-gray-900 bg-white rounded-md ring-1 ring-inset ring-gray-300 shadow-sm hover:bg-gray-50 sm:mt-0 sm:w-auto"
                            >
                                Cancel
                            </button>
                        </div>
                    </DialogPanel>
                </div>
            </div>
        </Dialog>
        <Dialog
            open={isSuccessModalOpen}
            onClose={() => setIsSuccessModalOpen(false)}
            className="relative z-50"
        >
            <DialogBackdrop
                transition
                className="fixed inset-0 bg-gray-500/75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
            />
            <div className="overflow-y-auto fixed inset-0 z-10 w-screen">
                <div className="flex justify-center items-center p-4 min-h-full text-center sm:p-0">
                    <DialogPanel
                        transition
                        className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 max-w-lg w-full data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
                    >
                        <div className="px-4 pt-5 pb-4 bg-white sm:p-6 sm:pb-4">
                            <div className="sm:flex sm:items-start">
                                <div className="mt-3 w-full text-center sm:ml-4 sm:mt-0 sm:text-left">
                                    <DialogTitle as="h3" className="text-base font-semibold text-green-600">
                                        Success!
                                    </DialogTitle>
                                    <div className="mt-2">
                                        <p className="text-sm/6">Message sent successfully!</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </DialogPanel>
                </div>
            </div>
        </Dialog>
        <Dialog
            open={isErrorModalOpen}
            onClose={() => setIsErrorModalOpen(false)}
            className="relative z-50"
        >
            <DialogBackdrop
                transition
                className="fixed inset-0 bg-gray-500/75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
            />
            <div className="overflow-y-auto fixed inset-0 z-10 w-screen">
                <div className="flex justify-center items-center p-4 min-h-full text-center sm:p-0">
                    <DialogPanel
                        transition
                        className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 max-w-lg w-full data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
                    >
                        <div className="px-4 pt-5 pb-4 bg-white sm:p-6 sm:pb-4">
                            <div className="sm:flex sm:items-start">
                                <div className="mt-3 w-full text-center sm:ml-4 sm:mt-0 sm:text-left">
                                    <DialogTitle as="h3" className="text-base font-semibold text-red-600">
                                        Error!
                                    </DialogTitle>
                                    <div className="mt-2">
                                        <p className="text-sm/6">Failed to send message. Please try again later.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </DialogPanel>
                </div>
            </div>
        </Dialog>
    </>
}
